import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

// Pages
import HomePage from "@/pages/HomePage";
import ServicePage from "@/pages/ServicePage";
import AboutPage from "@/pages/AboutPage";
import { BlogPage, BrandDetailPage } from "@/pages/BlogPage";
import SupportPage from "@/pages/SupportPage";
import ContactPage from "@/pages/ContactPage";
import DeviceTrackingPage from "@/pages/DeviceTrackingPage";
import AdminPage from "@/pages/AdminPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Main Pages */}
          <Route path="/" element={<HomePage />} />
          <Route path="/servis" element={<ServicePage />} />
          <Route path="/servis-al" element={<ServicePage />} />
          <Route path="/cihaz-sorgulama" element={<DeviceTrackingPage />} />
          <Route path="/hakkinda" element={<AboutPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:brand" element={<BrandDetailPage />} />
          <Route path="/destek" element={<SupportPage />} />
          <Route path="/iletisim" element={<ContactPage />} />
          
          {/* Hidden Admin Page */}
          <Route path="/yonetim-paneli" element={<AdminPage />} />
          
          {/* Fallback */}
          <Route path="*" element={<HomePage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
